import type { IconData } from '@stacksjs/iconify-core'

export const batteryThreeQuarters: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v8h15V2zm17 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2zm-8-1h2v8h-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default batteryThreeQuarters
